import RawVariable from '@/layouts/variables/RawVariable';
import VariableTagTree from '@/layouts/variables/VariableTagTree';
import VariableTag from '@/layouts/variables/VariableTag';
import RuleList from '@/layouts/rules/RuleList';
import Rule from '@/layouts/rules/Rule';
import RuleGroupal from '@/layouts/rules/RuleGroupal';
import RuleMenu from '@/layouts/rules/RuleMenu';
import Workspace from '@/layouts/Workspace';
import EventList from '@/layouts/events/EventList';
import QueryList from '@/layouts/queries/QueryList';
import Query from '@/layouts/queries/Query';
import PermissionList from '@/layouts/groups/PermissionList';
import Settings from 'BRAND/layouts/Settings';
import GroupList from '@/layouts/groups/GroupList';
import Group from '@/layouts/groups/Group';
import GroupUserList from '@/layouts/groups/GroupUserList';
import UserList from '@/layouts/user/UserList';
import GroupPermissionList from '@/layouts/groups/GroupPermissionList';
import UserProfile from 'BRAND/layouts/HealthUserProfile';
import ExplorerEvolutionVariables from '@/layouts/explorer/ExplorerEvolutionVariables';
import ExplorerEvolution from '@/layouts/explorer/ExplorerEvolution';
import PatientList from 'BRAND/layouts/patient/PatientList.vue';
import AssignPatients from 'BRAND/layouts/patient/AssignPatients.vue';
import NotificationMessageManagement from 'BRAND/layouts/notifications/NotificationMessageManagement.vue';
import AssignLicense from 'BRAND/layouts/AssignLicense.vue';
// import Explore from '@/layouts/explorer/Explore';
import ExplorerCorrelationVariables from '@/layouts/explorer/ExplorerCorrelationVariables';
import ExplorerCorrelation from '@/layouts/explorer/ExplorerCorrelation';
import ExplorerCorrelationMenu from '@/layouts/explorer/ExplorerCorrelationMenu';
import ExplorerMultipleCorrelationVariables from '@/layouts/explorer/ExplorerMultipleCorrelationVariables';
import ExplorerMultipleCorrelation from '@/layouts/explorer/ExplorerMultipleCorrelation';
import AggregateVariableMenu from '@/layouts/variables/AggregateVariableMenu';
import AggregateGradualVariable from '@/layouts/variables/AggregateGradualVariable';
import AggregateGradualVariableList from '@/layouts/variables/AggregateGradualVariableList';
import AggregateOperatedVariableList from '@/layouts/variables/AggregateOperatedVariableList';
import AggregateOperatedVariable from '@/layouts/variables/AggregateOperatedVariable';
import VariableManagement from '@/layouts/variables/VariableManagement';
import VariableCategory from '@/layouts/variables/VariableCategory';
import VariableCategoryList from '@/layouts/variables/VariableCategoryList';
import NightscoutUserList from '../layouts/NightscoutUserList';
import translationsEs from 'BRAND/i18n/es_ES/translations';
import translationsEn from 'BRAND/i18n/en_GB/translations';
import Legal from '@/layouts/Legal';
// import ChangePassphrase from '../layouts/ChangePassphrase';
import CsvIngest from '@/layouts/csv/CsvIngest';
import HealthExplorer from 'BRAND/layouts/HealthExplorer';
import MultipleBoard from 'BRAND/layouts/MultipleBoard';
import User from 'BRAND/layouts/HealthUser';
import EmailVerification from '@/layouts/EmailVerification';
import GpxIngest from 'BRAND/layouts/GpxIngest';
import FoodCompositionCsvIngest from 'BRAND/layouts/FoodCompositionCsvIngest';
import FoodManager from 'BRAND/layouts/FoodManager';
import ResetPasswordMail from '@/layouts/ResetPasswordMail';
import ResetPasswordForm from '@/layouts/ResetPasswordForm';
import PermissionAssignment from '@/layouts/PermissionAssignment';
import HealthLogin from 'BRAND/layouts/HealthLogin';
import UserSensorTime from 'BRAND/layouts/UserSensorTime';
import Integration from 'BRAND/layouts/Integration';
import HealthSummary from 'BRAND/layouts/HealthSummary';
import IngestList from 'BRAND/layouts/nutritionalPlan/IngestList';
import IngestTemplates from 'BRAND/layouts/nutritionalPlan/IngestTemplates';
import Ingest from 'BRAND/layouts/nutritionalPlan/Ingest';
import Template from 'BRAND/layouts/nutritionalPlan/Template';
import NutritionalPlanMenu from 'BRAND/layouts/nutritionalPlan/NutritionalPlanMenu';
import NutritionalPlan from 'BRAND/layouts/nutritionalPlan/NutritionalPlan';
import NutritionCalendar from 'BRAND/layouts/nutritionalPlan/NutritionCalendar';
import Supervisors from 'BRAND/layouts/Supervisors';
import ManageMyAccess from 'BRAND/layouts/ManageMyAccess';
import GlucoseUploader from 'BRAND/layouts/GlucoseUploader';
import LicenseManagement from 'BRAND/layouts/LicenseManagement.vue';
import AddLicense from 'BRAND/layouts/AddLicense.vue';
import ChallengeManagement from 'BRAND/layouts/challenge/ChallengeManagement';
import AddChallengeTemplate from 'BRAND/layouts/challenge/AddChallengeTemplate';
import ChallengeHistory from 'BRAND/layouts/challenge/ChallengeHistory';
import EditNotificationMessage from 'BRAND/layouts/notifications/EditNotificationMessage';
import AppFallback from 'BRAND/layouts/AppFallback';
import ExploreRecommendedPostsUpdate from 'BRAND/layouts/ExploreRecommendedPostsUpdate';
import RecipeList from 'BRAND/layouts/recipe/RecipeList';
import EditRecipe from 'BRAND/layouts/recipe/EditRecipe';
import RecipeTagList from 'BRAND/layouts/recipe/RecipeTagList';
import EditRecipeTag from 'BRAND/layouts/recipe/EditRecipeTag';
import Dashboard from 'BRAND/layouts/Dashboard.vue';
import CorporateGroupsList from 'BRAND/layouts/corporateGroups/CorporateGroupsList';

export default {
  /**
   * Default locale.
   */
  locale: 'es_ES',
  /*
   * Define home root page.
   */
  home: '/glucoboard',
  /**
   * Define fallback page.
   */
  defaultFallback: '/settings',
  /**
   * Define the enabled routes
   */
  routes: [
    {
      path: '/app/*',
      name: 'AppFallback',
      component: AppFallback
    },
    {
      path: '/login',
      name: 'Login',
      component: HealthLogin
    },
    {
      path: '/emailverification',
      name: 'EmailVerification',
      component: EmailVerification
    },
    {
      path: '/password/reset',
      name: 'ResetPasswordMail',
      component: ResetPasswordMail
    },
    {
      path: '/password/newpassword',
      name: 'ResetPasswordForm',
      component: ResetPasswordForm
    },
    {
      path: '/legal',
      name: 'Legal',
      component: Legal
    },
    {
      path: '/aggregate-variable/operated/list',
      name: 'AggregateOperatedVariableList',
      component: AggregateOperatedVariableList,
      meta: {feature: 'AggregateVariable'}
    },
    {
      path: '/aggregate-variable/operated',
      name: 'AggregateOperatedVariable',
      component: AggregateOperatedVariable,
      meta: {feature: 'AggregateVariable'}
    },
    {
      path: '/aggregate-variable/menu',
      name: 'AggregateVariableMenu',
      component: AggregateVariableMenu,
      meta: {feature: 'AggregateVariable'}
    },
    {
      path: '/aggregate-variable/gradual',
      name: 'AggregateGradualVariable',
      component: AggregateGradualVariable,
      meta: {feature: 'AggregateVariable'}
    },
    {
      path: '/aggregate-variable/gradual/list',
      name: 'AggregateGradualVariableList',
      component: AggregateGradualVariableList,
      meta: {feature: 'AggregateVariable'}
    },
    {
      path: '/rule/list',
      name: 'RuleList',
      component: RuleList,
      meta: {feature: 'Rule'}
    },
    {
      path: '/rule',
      name: 'Rule',
      component: Rule,
      meta: {feature: 'Rule'}
    },
    {
      path: '/groupal-rule',
      name: 'RuleGroupal',
      component: RuleGroupal,
      meta: {feature: 'Rule'}
    },
    {
      path: '/rule/add',
      name: 'RuleMenu',
      component: RuleMenu,
      meta: {feature: 'Rule'}
    },
    {
      path: '/supervisors',
      name: 'Supervisors',
      component: Supervisors
    },
    {
      path: '/manage-my-access',
      name: 'ManageMyAccess',
      component: ManageMyAccess
    },
    {
      path: '/workspace',
      name: 'Workspace',
      component: Workspace,
      meta: {feature: 'Workspace'}
    },
    {
      path: '/event/list',
      name: 'EventList',
      component: EventList,
      meta: {feature: 'EventList'}
    },
    {
      path: '/query/list',
      name: 'QueryList',
      component: QueryList,
      meta: {feature: 'Query'}
    },
    {
      path: '/query',
      name: 'Query',
      component: Query,
      meta: {feature: 'Query'}
    },
    {
      path: '/:type/:id/permission/list',
      name: 'Permissions',
      component: PermissionList,
      meta: {feature: 'UsersGroupsAndPermissions'}
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings
    },
    {
      path: '/integration',
      name: 'integration',
      component: Integration,
      meta: {feature: 'Integration'}
    },
    {
      path: '/glucoseUploader',
      name: 'glucoseUploader',
      component: GlucoseUploader
    },
    {
      path: '/group/list',
      name: 'GroupList',
      component: GroupList,
      meta: {feature: 'UsersGroupsAndPermissions'}
    },
    {
      path: '/group',
      name: 'Group',
      component: Group,
      meta: {feature: 'UsersGroupsAndPermissions'}
    },
    {
      path: '/group/user/list',
      name: 'GroupUserList',
      component: GroupUserList,
      meta: {feature: 'UsersGroupsAndPermissions'}
    },
    {
      path: '/user/list',
      name: 'UserList',
      component: UserList,
      meta: {feature: 'UsersGroupsAndPermissions'}
    },
    {
      path: '/user',
      name: 'User',
      component: User,
      meta: {feature: 'UsersGroupsAndPermissions'}
    },
    {
      path: '/group/permission/list',
      name: 'GroupPermissionList',
      component: GroupPermissionList,
      meta: {feature: 'UsersGroupsAndPermissions'}
    },
    {
      path: '/user-profile',
      name: 'UserProfile',
      component: UserProfile
    },
    /**
     {
      path: '/explore',
      name: 'Explore',
      component: Explore,
      meta: {feature: 'Explore'}
    },
     */
    {
      path: '/explorer-evolution-variables',
      name: 'ExplorerEvolutionVariables',
      component: ExplorerEvolutionVariables
    },
    {
      path: '/explorer-evolution',
      name: 'ExplorerEvolution',
      component: ExplorerEvolution,
      meta: {feature: 'Explore'}
    },
    {
      path: '/explorer-correlation-variables',
      name: 'ExplorerCorrelationVariables',
      component: ExplorerCorrelationVariables,
      meta: {feature: 'Explore'}
    },
    {
      path: '/explorer-correlation',
      name: 'ExplorerCorrelation',
      component: ExplorerCorrelation,
      meta: {feature: 'Explore'}
    },
    {
      path: '/explorer-correlation/menu',
      name: 'ExplorerCorrelationMenu',
      component: ExplorerCorrelationMenu,
      meta: {feature: 'ExplorerCorrelationBenchmark'}
    },
    {
      path: '/explorer-multiple-correlation-variables',
      name: 'ExplorerMultipleCorrelationVariables',
      component: ExplorerMultipleCorrelationVariables,
      meta: {feature: 'Explore'}
    },
    {
      path: '/explorer-multiple-correlation',
      name: 'ExplorerMultipleCorrelation',
      component: ExplorerMultipleCorrelation,
      meta: {feature: 'Explore'}
    },
    {
      path: '/raw-variable',
      name: 'RawVariable',
      component: RawVariable,
      meta: {feature: 'RawVariable'}
    },
    {
      path: '/tags-tree',
      name: 'VariableTagTree',
      component: VariableTagTree,
      meta: {feature: 'Taxonomy'}
    },
    {
      path: '/tags',
      name: 'VariableTag',
      component: VariableTag,
      meta: {feature: 'Taxonomy'}
    },
    {
      path: '/variable-management',
      name: 'VariableManagement',
      component: VariableManagement,
      meta: {feature: 'Admin'}
    },
    {
      path: '/categorical-variable',
      name: 'VariableCategory',
      component: VariableCategory,
      meta: {feature: 'Admin'}
    },
    {
      path: '/categorical-variable/list',
      name: 'VariableCategoryList',
      component: VariableCategoryList,
      meta: {feature: 'Admin'}
    },
    {
      path: '/xugar/nightscout/user/list',
      name: 'NightscoutUserList',
      component: NightscoutUserList,
      meta: {feature: 'NightscoutUserList'}
    },
    /**
     {
      path: '/xugar/nightscout/user/changepassphrase',
      name: 'ChangePassphrase',
      component: ChangePassphrase
    }, */
    {
      path: '/csv-uploader',
      name: 'CsvIngest',
      component: CsvIngest,
      meta: {feature: 'Superadmin'}
    },
    {
      path: '/gpx-uploader',
      name: 'GpxIngest',
      component: GpxIngest,
      meta: {feature: 'Explore'}
    },
    {
      path: '/user-sensor',
      name: 'UserSensor',
      component: UserSensorTime,
      meta: {feature: 'UserSensorTime'}
    },
    {
      path: '/glucoboard',
      name: 'HealthExplorer',
      component: HealthExplorer
    },
    {
      path: '/glucoboard/multiscreen',
      name: 'MultipleBoard',
      component: MultipleBoard,
      meta: {feature: 'Board'}
    },
    {
      path: '/summary',
      name: 'HealthSummary',
      component: HealthSummary
    },
    {
      path: '/csv-food-composition-uploader',
      name: 'FoodCompositionCsvIngest',
      component: FoodCompositionCsvIngest,
      meta: {feature: 'FoodManager'}
    },
    {
      path: '/food-manager',
      name: 'FoodManager',
      component: FoodManager,
      meta: {feature: 'FoodManager'}
    },
    {
      path: '/permission-assignment',
      name: 'PermissionAssignment',
      component: PermissionAssignment,
      meta: {feature: 'PermissionAssignment'}
    },
    {
      path: '/nutritionalPlan',
      name: 'NutritionalPlan',
      component: NutritionalPlan
    },
    {
      path: '/nutritionalPlan/menu',
      name: 'NutritionalPlanMenu',
      component: NutritionalPlanMenu,
      meta: {feature: 'NutritionalPlan'}
    },
    {
      path: '/ingest',
      name: 'IngestList',
      component: IngestList,
      meta: {feature: 'NutritionalPlan'}
    },
    {
      path: '/ingest/templates',
      name: 'IngestTemplates',
      component: IngestTemplates,
      meta: {feature: 'NutritionalPlan'}
    },
    {
      path: '/ingest/template',
      name: 'Template',
      component: Template,
      meta: {feature: 'NutritionalPlan'}
    },
    {
      path: '/ingest/edit',
      name: 'Ingest',
      component: Ingest,
      meta: {feature: 'NutritionalPlan'}
    },
    {
      path: '/calendar',
      name: 'NutritionCalendar',
      component: NutritionCalendar,
      meta: {feature: 'NutritionalPlan'}
    },
    {
      path: '/licenseManagement',
      name: 'LicenseManagement',
      component: LicenseManagement,
      meta: {feature: 'Admin'}
    },
    {
      path: '/addLicense',
      name: 'AddLicense',
      component: AddLicense,
      meta: {feature: 'Admin'}
    },
    {
      path: '/patients',
      name: 'PatientList',
      component: PatientList,
      meta: {feature: 'Patients'}
    },
    {
      path: '/assign-patients',
      name: 'AssignPatients',
      component: AssignPatients,
      meta: {feature: 'AssignPatients'}
    },
    {
      path: '/challenge-management',
      name: 'ChallengeManagement',
      component: ChallengeManagement,
      meta: {feature: 'Superadmin'}
    },
    {
      path: '/add-challenge-template',
      name: 'AddChallengeTemplate',
      component: AddChallengeTemplate,
      meta: {feature: 'Superadmin'}
    },
    {
      path: '/challenge/history',
      name: 'ChallengeHistory',
      component: ChallengeHistory,
      meta: {feature: 'Superadmin'}
    },
    {
      path: '/notification-messages',
      name: 'NotificationMessageManagement',
      component: NotificationMessageManagement,
      meta: {feature: 'NotificationMessages'}
    },
    {
      path: '/notification-messages/edit',
      name: 'EditNotificationMessage',
      component: EditNotificationMessage,
      meta: {feature: 'NotificationMessages'}
    },
    {
      path: '/assign-license',
      name: 'AssignLicense',
      component: AssignLicense,
      meta: {feature: 'Board'}
    },
    {
      path: '/explore-recommended-posts',
      name: 'ExploreRecommendedPostsUpdate',
      component: ExploreRecommendedPostsUpdate,
      meta: {feature: 'ExploreRecommendedPostsUpdate'}
    },
    {
      path: '/recipe',
      name: 'RecipeList',
      component: RecipeList,
      meta: {feature: 'ManageRecipes'}
    },
    {
      path: '/recipe/add',
      name: 'AddRecipe',
      component: EditRecipe,
      meta: {feature: 'ManageRecipes'}
    },
    {
      path: '/recipe/edit',
      name: 'EditRecipe',
      component: EditRecipe,
      meta: {feature: 'ManageRecipes'}
    },
    {
      path: '/recipe-tag',
      name: 'RecipeTagList',
      component: RecipeTagList,
      meta: {feature: 'ManageRecipes'}
    },

    {
      path: '/recipe-tag/add',
      name: 'AddRecipeTag',
      component: EditRecipeTag,
      meta: {feature: 'ManageRecipes'}
    },
    {
      path: '/recipe-tag/edit',
      name: 'EditRecipeTag',
      component: EditRecipeTag,
      meta: {feature: 'ManageRecipes'}
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {feature: 'DashboardManagement'}
    },
    {
      path: '/corporate-groups',
      name: 'CorporateGroupsList',
      component: CorporateGroupsList,
      meta: {feature: 'CorporateGroupsManagement'}
    }
  ],
  featurePermission: [
    {
      feature: 'Superadmin',
      authorities: ['ROLE_SUPERADMIN']
    },
    {
      feature: 'Admin',
      authorities: ['ROLE_SUPERADMIN', 'ROLE_ADMIN']
    },
    {
      feature: 'NutriAdmin',
      authorities: ['ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_ADMIN_NUTRI']
    },
    {
      feature: 'Nutri',
      authorities: ['ROLE_NUTRI']
    },
    {
      feature: 'Explorer',
      authorities: ['ROLE_ADMIN', 'EXPLORER']
    },
    {
      feature: 'Explore',
      authorities: ['ROLE_ADMIN', 'EXPLORER']
    },
    {
      feature: 'PermissionAssignment',
      authorities: ['ROLE_SUPERADMIN', 'ROLE_ADMIN_NUTRI', 'ROLE_ADMIN']
    },
    {
      feature: 'UserSensorTime',
      authorities: ['ROLE_ADMIN', 'ROLE_ADMIN_NUTRI', 'ROLE_NUTRI']
    },
    {
      feature: 'NutritionalPlan',
      authorities: ['ROLE_ADMIN', 'ROLE_ADMIN_NUTRI', 'ROLE_NUTRI', 'ROLE_PRESCRIPTOR']
    },
    {
      feature: 'ExplorerCorrelationBenchmark',
      authorities: ['ROLE_SUPERADMIN']
    },
    {
      feature: 'Dashboard',
      authorities: ['ROLE_ADMIN', 'DASHBOARD']
    },
    {
      feature: 'Market',
      authorities: ['ROLE_ADMIN', 'MARKET']
    },
    {
      feature: 'Consultas',
      authorities: ['ROLE_ADMIN', 'LEVELSANDRHYTHMS']
    },
    {
      feature: 'AggregateVariable',
      authorities: ['ROLE_ADMIN']
    },
    {
      feature: 'Query',
      authorities: ['ROLE_ADMIN', 'QUERY']
    },
    {
      feature: 'Rule',
      authorities: ['ROLE_ADMIN', 'RULE']
    },
    {
      feature: 'RawVariable',
      authorities: ['ROLE_SUPERADMIN']
    },
    {
      feature: 'UsersGroupsAndPermissions',
      authorities: ['ROLE_ADMIN']
    },
    {
      feature: 'Workspace',
      authorities: ['ROLE_SUPERADMIN', 'ROLE_ADMIN', 'RULE', 'AGGREGATEVAR', 'QUERY']
    },
    {
      feature: 'EventList',
      authorities: ['ROLE_ADMIN', 'RULE']
    },
    {
      feature: 'NightscoutUserList',
      authorities: ['ROLE_ADMIN']
    },
    {
      feature: 'Admin',
      authorities: ['ROLE_ADMIN']
    },
    {
      feature: 'Ring',
      authorities: ['ROLE_PRESCRIPTOR']
    },
    {
      feature: 'Viber',
      authorities: ['ROLE_VIBER']
    },
    {
      feature: 'NutritionalPlanUser',
      authorities: ['ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_NUTRI', 'ROLE_NUTRI_ADMIN', 'ROLE_VIBER_PLUS']
    },
    {
      feature: 'Workspace',
      authorities: ['ROLE_SUPERADMIN', 'ROLE_ADMIN', 'RULE', 'AGGREGATEVAR', 'QUERY']
    },
    {
      feature: 'Board',
      authorities: ['ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_ADMIN_NUTRI', 'ROLE_NUTRI', 'BOARD']
    },
    {
      feature: 'Multiboard',
      authorities: ['ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_ADMIN_NUTRI', 'ROLE_NUTRI', 'ROLE_PRESCRIPTOR', 'MULTIBOARD']
    },
    {
      feature: 'Summary',
      authorities: ['ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_ADMIN_NUTRI', 'ROLE_NUTRI', 'SUMMARY']
    },
    {
      feature: 'Integration',
      authorities: ['ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_ADMIN_NUTRI', 'ROLE_NUTRI', 'INTEGRATION']
    },
    {
      feature: 'Taxonomy',
      authorities: ['ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_ADMIN_NUTRI', 'ROLE_NUTRI', 'TAXONOMY']
    },
    {
      feature: 'Patients',
      authorities: ['ROLE_ADMIN', 'ROLE_ADMIN_NUTRI', 'ROLE_NUTRI']
    },
    {
      feature: 'AssignPatients',
      authorities: ['ROLE_ADMIN', 'ROLE_ADMIN_NUTRI']
    },
    {
      feature: 'NotificationMessages',
      authorities: ['ROLE_SUPERADMIN', 'ROLE_ADMIN']
    },
    {
      feature: 'FoodManager',
      authorities: ['ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_NUTRI']
    },
    {
      feature: 'ExploreRecommendedPostsUpdate',
      authorities: ['ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_ADMIN_NUTRI', 'ROLE_NUTRI']
    },
    {
      feature: 'ManageRecipes',
      authorities: ['ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_ADMIN_NUTRI', 'ROLE_NUTRI']
    },
    {
      feature: 'DashboardManagement',
      authorities: ['ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PRESCRIPTOR']
    },
    {
      feature: 'CorporateGroupsManagement',
      authorities: ['ROLE_SUPERADMIN', 'ROLE_ADMIN']
    }
  ],
  /**
   * Define the main menu entries.
   */
  mainMenuEntries: [
    {
      routeName: 'HealthExplorer',
      label: 'health.healthBoard'
    },
    {
      routeName: 'HealthSummary',
      label: 'health.summary.title'
    },
    {
      routeName: 'ExplorerEvolutionVariables',
      label: 'menu.explorer'
    },
    {
      routeName: 'NutritionalPlan',
      label: 'health.nutritionalPlan.menu'
    }
    /**
     ,
     {
      routeName: 'NightscoutUserList',
      label: 'health.nightScout'
    },
     {
      routeName: 'ChangePassphrase',
      label: 'health.changePassphrase.title'
    } */
  ],
  /**
   * Define the assignable permissions.
   */
  assignablePermissions: [
    {
      name: 'explorer',
      label: 'menu.explorer',
      children: [
        {
          name: 'query',
          label: 'menu.queries'
        },
        {
          name: 'taxonomy',
          label: 'menu.taxonomy'
        }
      ]
    },
    {
      name: 'rule',
      label: 'group.permissions.rulesAndEvents'
    },
    {
      name: 'aggregateVar',
      label: 'group.permissions.aggregateVariable'
    },
    {
      name: 'board',
      label: 'group.permissions.board',
      children: [
        {
          name: 'multiboard',
          label: 'group.permissions.multiboard'
        }
      ]
    },
    {
      name: 'summary',
      label: 'group.permissions.summary'
    },
    {
      name: 'integration',
      label: 'group.permissions.integration'
    },
    {
      name: 'nutritionalPlan',
      label: 'group.permissions.nutritionalPlan'
    },
    {
      name: 'glucose',
      label: 'group.permissions.glucose'
    }
  ],
  /**
   * Define the initial date filter time lapse on explorer layout.
   * It is used to set the initial date filter values. Mandatory if explorer is enabled.
   */
  explorerDefaultDate: {
    startOf: 'day',
    unit: 'd',
    gapBegin: 7,
    gapEnd: 0
  },
  /**
   * Minimal selectable date into explorer filter. Optional.
   */
  minDate: new Date('2013-12-31 00:00:00+2:00'),
  /**
   * Google Analytics tracking code.
   */
  trackingCode: '268808464',
  /**
   * Translations.
   */
  i18n: {
    es_ES: translationsEs,
    en_GB: translationsEn
  },
  /**
   * Term and conditions i18n key.
   */
  termAndConditions: 'legal-termAndConditions',
  privacyPolicy: 'legal-privacyPolicy'
};



// WEBPACK FOOTER //
// ./src/brand/health/config/index.js